import type {
  BaseResult,
  Options,
} from "@umijs/plugins/node_modules/@ahooksjs/use-request/es/types";
// import { useRequest as useUmiRequest } from '@umijs/max';
import { useRequest as useUmiRequest } from "@@/plugin-request";
import type {
  RequestConfig,
  RequestFunctionRestArgs,
} from "yapi-to-typescript";
import type { default as baseRequest, default as request } from "./request";

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig["requestDataOptional"] extends true
  ? (
      requestData?: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

export default function makeRequestHook<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult extends ReturnType<typeof baseRequest>,
>(requestFunc: Request<TRequestData, TRequestConfig, TRequestResult>) {
  type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;
  return (
    options: Options<Data, Parameters<typeof requestFunc>, Data, Data> = {},
  ): BaseResult<Data, Parameters<typeof requestFunc>> =>
    // @ts-ignore
    useUmiRequest(requestFunc, options);
  // type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;
  // return function useRequest(
  //   _requestData: TRequestData,
  //   options: Options<any, any, any, any> = {},
  // ): BaseResult<Data, any> {
  //   return useUmiRequest(requestFunc, options);
  // };

  // type Data = TRequestResult extends Promise<infer R> ? R : TRequestResult;
  // return function useRequest(requestData: TRequestData, options) {
  //   // 一个简单的 Hook 实现，实际项目可结合其他库使用，比如：
  //   // @umijs/hooks 的 useRequest (https://github.com/umijs/hooks)
  //   // swr (https://github.com/zeit/swr)
  //
  //   const [loading, setLoading] = useState(true);
  //   const [data, setData] = useState<Data>();
  //
  //   useEffect(() => {
  //     request(requestData).then((res) => {
  //       setLoading(false);
  //       setData(res as any);
  //     });
  //   }, [JSON.stringify(requestData)]);
  //
  //   return {
  //     loading,
  //     data,
  //   };
  // };
}
